import { FC } from 'react';
import RangeCalculator, { IRangeCalculatorProps } from 'core/components/Calculator/RangeCalculator';
import './style.scss';

interface IRangeSliderProps extends IRangeCalculatorProps {

}

export const RangeSlider: FC<Omit<IRangeSliderProps, 'buttonMinus' | 'buttonPlus'>> = (props) => (
  <RangeCalculator
    {...props}
    prefixPosition={props.prefixPosition || 'first'}
    buttonMinus={<span className="minus"/>}
    buttonPlus={<span className="plus"/>}
  />
);
